// extracted by mini-css-extract-plugin
export var imageLink = "jumpToBrand-module--imageLink--k+lCA";
export var linksList = "jumpToBrand-module--linksList--QIWtc";
export var wrapper = "jumpToBrand-module--wrapper--NeoHh";